module.exports = __webpack_public_path__ + "static/media/kayanLogo.c8d615a7.jpg";